<template>
  <div class="follow">
    <CubePage type="myorder-view" title="红包" :backurl="'/My'">
      <div slot="content" class="contenthb">
        <van-tabs v-model="active" sticky background="#edf0f4" color="#f0b86e" @change="onChanageTab">
          <van-tab :key="index" v-for="(item,index) in tabls" :title="item"></van-tab>
        </van-tabs>
        <div class="content">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh(4)">
            <!-- <van-empty
              v-if="isNoData"
              class="custom-image"
              image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
              description="您还没有相关的订单"
            /> -->
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad()"
              :immediate-check="false"
            >
              <div class="hblistbox" v-for="item in retData" :key="item.id">
                <!-- <div class="leftimg"></div> -->
                <div class="bcontent">
                  <van-tag type="warning">{{item.status_text}}</van-tag>
                  <!-- <div class="name">{{item.status_text}}</div> -->
                  <div class="timer">{{item.createtime}}</div>
                </div>
                <div class="rightje">
                  <span>{{item.reward_value}}</span> 元
                </div>
              </div>

              <!-- <div class="hblistbox" v-for="item in retData" :key="item.id">
                <div class="leftimg">
                  <van-tag type="success">已发放</van-tag>
                </div>
                <div class="timer">{{item.createtime}}</div>
                <div class="rightje">
                  <span>0.05</span> 元
                </div>
              </div> -->
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </CubePage>
  </div>
</template>

<script>
import CubePage from "../TP/cube-page.vue";
import * as util from "@/utils/network";
import wx from "weixin-js-sdk";
import { Dialog } from "vant";
export default {
  components: {
    CubePage
  },
  data() {
    return {
      tabls: ["全部", "待发放", "已发放"],
      active: 0,
      retData: [],
      loading: false,
      finished: false,
      pageIndex: 1,
      pageTotal: 0,
      refreshing: false,
      isNoData: false
    };
  },
  created() {
    this.getData();
  },
  methods: {
      onChanageTab(name,value){
        this.clearContainer();
        this.getData();
        console.log(name,value)
        console.log(this.active)
      },
    //下拉刷新
    onRefresh(status) {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态

      this.refreshing = true;
      this.getData();
    },
    onLoad() {
      let that = this;
      // 异步更新数据
      that.pageIndex++;
      setTimeout(() => {
        that.getData();
      }, 100);
    },
    getData() {
      var url = "/addons/litestore/api.reward/log";
      let that = this;
      if (that.refreshing) {
        that.clearContainer();
        that.refreshing = false;
      }
      if (that.pageIndex > 1 && that.retData.length >= that.pageTotal) {
        that.finished = true;
        return;
      }
      this.loading = true;
      var ac =  that.active>0?that.active+'0':''
      var params = {
          status:ac,
        reward_type: 10,
        page: that.pageIndex
      };
      //这里直接调用网络接口
      util.post(url, params, function(result) {
        console.log("object", result);
        that.loading = false;
        //这里对状态 进行分类
        that.pageTotal = result.data.total;
        if (that.pageTotal < 1) {
          that.isNoData = true;
          return;
        }
        if (result.data.list == null || result.data.list.length === 0) {
          // 加载结束
          that.finished = true;
          return;
        }
        // 将新数据与老数据进行合并
        that.retData = that.retData.concat(result.data.list);
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.retData.length >= that.pageTotal) {
          that.finished = true;
        }
        // if (result.data) {
        //   //   that.show = result.data.total > 0 ? true : false;
        //   that.retData = result.data;
        //   console.log(that.retData);
        // }
      });
    }, // 初始化数据
    clearContainer() {
      this.loading = false;
      this.finished = false;
      this.retData = [];
      this.isNoData = false;
      this.pageIndex = 1;
      this.pageTotal = 0;
    }
  }
};
</script>
<style lang="less" scoped="scoped">
/deep/ .cube-page > .wrapper {
  background-color: rgb(255, 255, 255);
}

.content {
  padding: 10px;
  box-sizing: border-box;
}
.hblistbox {
  padding: 10px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  .bcontent{
      flex: 1;
  }
  .leftimg {
    width: 100px;
  }
  .timer {
    flex: 1;
    font-size: 12px;
    line-height: 30px;
  }
  .rightje {
    width: 100px;
    text-align: right;
    color: #ee0a24;
    font-size: 12px;
    span {
      font-size: 18px;
    }
  }
}
</style>
